import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const USER_UPDATE_GUEST_RESOURCE = "user/update-guest" as const;
export const USER_UPDATE_GUEST_API_PATH = `/v1/${USER_UPDATE_GUEST_RESOURCE}/{uuid}` as const;

export type MutationBody =
  paths[typeof USER_UPDATE_GUEST_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type MutationResponse =
  paths[typeof USER_UPDATE_GUEST_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useUserUpdateGuestMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<MutationResponse, Error, MutationBody & { uuid: string }>({
    mutationFn: async (user: MutationBody & { uuid: string }) => {
      const { uuid, ...rest } = user;
      const response = await alphartisApiAxios.patch<MutationResponse>(
        `/v1/${USER_UPDATE_GUEST_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [USER_UPDATE_GUEST_RESOURCE],
      });
    },
  });
};
